import { Box, Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { Card } from "../../modules";
import { StepTimeline } from "../../../../modules/StepTimeline/StepTimeline";

export const Introduction = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>導入プロセス</SectionTitle>
      <SectionSubtitle>スムーズな導入をサポートする、段階的なプロセス設計</SectionSubtitle>

      <Box sx={introductionContainerSx}>
        <StepTimeline
          steps={[
            {
              title: "ヒアリング・要件定義",
              description: "現在の運用状況、課題、要件を詳細にヒアリングし、最適な運用設計を提案",
              caption: "期間: 1週間",
            },
            {
              title: "運用設計",
              description: "監視設計、運用フロー、SLA設定、セキュリティ要件を詳細に設計",
              caption: "期間: 1週間",
            },
            {
              title: "プラットフォーム構築",
              description: "専用の監視プラットフォーム、アラート設定、エージェントインストール",
              caption: "期間: 1週間",
            },
            {
              title: "運用引き継ぎ",
              description: "既存運用からの移行、運用ルールの確立、チーム間の連携体制構築",
              caption: "期間: 1週間",
            },
            {
              title: "本格運用開始",
              description: "24時間365日の監視・運用開始。定期的な改善提案とレポート提供",
              caption: "期間: 継続",
            },
          ]}
        />

        <Box sx={highlightContainerSx}>
          <Box sx={highlightBadgeSx}>
            <Typography sx={highlightTextSx}>1ヶ月で導入可能！</Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ marginTop: "60px" }}>
        <Typography variant="h3" sx={detailsTitleSx}>
          移行支援内容
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card variant="light">
              <Card.Title>既存システム移行</Card.Title>
              <Typography variant="body2" sx={detailsItemDescriptionSx}>
                現在の監視ツールからテクノスタンダードの監視プラットフォームへの移行をサポート。データの移行、設定の引き継ぎ、動作確認まで一貫して対応します。
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card variant="light">
              <Card.Title>運用体制構築</Card.Title>
              <Typography variant="body2" sx={detailsItemDescriptionSx}>
                既存の運用チームとの連携体制、エスカレーションルール、報告体制を構築。スムーズな運用引き継ぎを実現します。
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card variant="light">
              <Card.Title>初期費用</Card.Title>
              <Typography variant="body2" sx={detailsItemDescriptionSx}>
                初期費用: お問い合わせください
                <br />
                内容: 要件定義、運用設計、プラットフォーム構築、移行支援
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card variant="light">
              <Card.Title>必要な準備</Card.Title>
              <Typography variant="body2" sx={detailsItemDescriptionSx}>
                システム構成図、現在の運用ルール、SLA要件、セキュリティ要件の整理。担当者との定期的な打ち合わせ体制の構築。
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </SectionContainer>
  );
};

const introductionContainerSx: SxProps<Theme> = {
  background: "white",
  padding: "40px",
  borderRadius: "20px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  border: "3px solid transparent",
  position: "relative",
};

const highlightContainerSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mt: 4,
  mb: 2,
};

const highlightBadgeSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
  borderRadius: "25px",
  padding: "10px 24px",
  boxShadow: "0 4px 15px rgba(40, 167, 69, 0.2)",
};

const highlightTextSx: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  textAlign: "center",
  fontSize: "1.1rem",
  letterSpacing: "0.3px",
  textShadow: "0 1px 2px rgba(0,0,0,0.2)",
};

const detailsTitleSx: SxProps<Theme> = {
  textAlign: "center",
  fontSize: "2rem",
  marginBottom: "40px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const detailsItemDescriptionSx: SxProps<Theme> = {
  color: "#666",
  fontSize: "0.95rem",
  lineHeight: 1.6,
};
